import { render, staticRenderFns } from "./Quadros_Gestao.vue?vue&type=template&id=77805b22"
import script from "./Quadros_Gestao.vue?vue&type=script&lang=js"
export * from "./Quadros_Gestao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports